export default interface APIData{
    total: number;
    next: string;
    previous: string;
    results: Array<any>;
    current_page: number;
    total_pages: number;
    page_size: number;
}

export function setDefaultAPIData(): APIData {
    return {
      total: 0,
      next: '',
      previous: '',
      results: [],
      current_page: 1,
      total_pages: 1,
      page_size: 10,
    };
  }